export default function getCurrentUser(state) {
  return state.currentUser;
}
